import { MODE_SKILLS } from './bkt.js';
import { initBkt } from './bkt.js';
import { getDueWords } from './leitner.js';
import { getSpellingWords } from './spelling.js';

export const FUN_MODE_LABELS = {
  phonics: {emoji:'🔤',label:'Sound Adventure!',desc:'Practice letter sounds'},
  sight: {emoji:'👁️',label:'Find Cool Words!',desc:'Learn new vocabulary'},
  stories: {emoji:'📖',label:'Story Time!',desc:'Read and answer questions'},
  bubbles: {emoji:'🫧',label:'Pop & Play!',desc:'Pop word bubbles'}
};

export function buildSessionPlaylist(tracker, profile, timerMinutes) {
  try {
    const level = tracker.currentLevel;
    const age = profile.age || 7;
    const bkt = tracker.bkt || initBkt(level);
    if (level <= 3) return [{ mode: 'phonics', minutes: timerMinutes, reason: 'Pre-reader phonics focus' }];
    const modes = ['phonics', 'sight', 'stories'];
    if (tracker.bubbleUnlocked) modes.push('bubbles');
    const modeGaps = {};
    for (const mode of modes) {
      const skill = (MODE_SKILLS[mode] || {})[level];
      const pL = skill ? (bkt[skill] || 0.1) : 0.5;
      modeGaps[mode] = Math.max(0, 0.95 - pL);
    }
    const dueCount = getDueWords(tracker.wordMastery, age, 100).length;
    if (dueCount > 5) { modeGaps.sight += 0.2; if (modeGaps.bubbles !== undefined) modeGaps.bubbles += 0.15; }
    else if (dueCount > 0) { modeGaps.sight += 0.1; if (modeGaps.bubbles !== undefined) modeGaps.bubbles += 0.05; }
    const spWords = getSpellingWords(profile?.id);
    if (spWords.length > 0) { modeGaps.sight = (modeGaps.sight || 0) + 0.25; modeGaps.phonics = (modeGaps.phonics || 0) + 0.15; if (modeGaps.bubbles !== undefined) modeGaps.bubbles += 0.15; }
    if (level >= 7) modeGaps.stories = Math.max(modeGaps.stories || 0, 0.4);
    const totalGap = Object.values(modeGaps).reduce((s, g) => s + g, 0);
    if (totalGap < 0.01) {
      const count = Math.max(2, Math.min(modes.length, Math.ceil(timerMinutes / 4)));
      return modes.slice(0, count).map(mode => ({ mode, minutes: Math.round(timerMinutes / count), reason: 'Review' }));
    }
    const numRounds = Math.max(2, Math.min(8, Math.ceil(timerMinutes / 4)));
    const weightedModes = Object.entries(modeGaps).filter(([_, g]) => g > 0.01).sort((a, b) => b[1] - a[1]);
    if (weightedModes.length === 0) return null;
    const roundAlloc = {};
    let remaining = numRounds;
    for (const [mode, gap] of weightedModes) {
      const rounds = Math.max(1, Math.round((gap / totalGap) * numRounds));
      roundAlloc[mode] = Math.min(rounds, remaining);
      remaining -= roundAlloc[mode];
      if (remaining <= 0) break;
    }
    if (remaining > 0) roundAlloc[weightedModes[0][0]] = (roundAlloc[weightedModes[0][0]] || 0) + remaining;
    if (level >= 7 && roundAlloc.stories !== undefined) {
      const totalRnds = Object.values(roundAlloc).reduce((s, c) => s + c, 0);
      const minStoryRnds = Math.max(1, Math.ceil(totalRnds * 0.3));
      if ((roundAlloc.stories || 0) < minStoryRnds) {
        const deficit = minStoryRnds - (roundAlloc.stories || 0);
        roundAlloc.stories = minStoryRnds;
        const sorted = Object.entries(roundAlloc).filter(([m]) => m !== 'stories').sort((a, b) => b[1] - a[1]);
        if (sorted.length > 0 && sorted[0][1] > 1) {
          roundAlloc[sorted[0][0]] = Math.max(1, sorted[0][1] - deficit);
        }
      }
    }
    if (Object.keys(roundAlloc).length < 2 && weightedModes.length >= 2) {
      const top = weightedModes[0][0], second = weightedModes[1][0];
      if (roundAlloc[top] > 1) { roundAlloc[top]--; roundAlloc[second] = (roundAlloc[second] || 0) + 1; }
    }
    const playlist = [];
    const mq = { ...roundAlloc };
    let lastMode = null;
    const total = Object.values(mq).reduce((s, c) => s + c, 0);
    for (let i = 0; i < total; i++) {
      let best = null, bestCount = 0;
      for (const [mode, count] of Object.entries(mq)) {
        if (count <= 0) continue;
        if (mode !== lastMode && count >= bestCount) { best = mode; bestCount = count; }
      }
      if (!best) for (const [mode, count] of Object.entries(mq)) { if (count > 0) { best = mode; break; } }
      if (!best) break;
      playlist.push({ mode: best, minutes: Math.round(timerMinutes / total), reason: (modeGaps[best] || 0) > 0.5 ? 'Needs practice' : 'Building mastery' });
      mq[best]--;
      lastMode = best;
    }
    return playlist.length >= 1 ? playlist : null;
  } catch (e) {
    console.warn('Playlist generation failed:', e);
    return null;
  }
}
